import { render, staticRenderFns } from "./activity4_m.vue?vue&type=template&id=60215fbb&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./activity4_m.vue?vue&type=script&lang=js"
export * from "./activity4_m.vue?vue&type=script&lang=js"
import style0 from "../assets/windows.scss?vue&type=style&index=0&id=60215fbb&prod&lang=scss&scoped=true&external"
import style1 from "./activity4_m.vue?vue&type=style&index=1&id=60215fbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60215fbb",
  null
  
)

export default component.exports